import React from 'react';
import { useMutation, useQueryClient } from 'react-query';
import { message } from 'antd';
import { maxFileSize } from '../../../constants/maxFileSize';
import useRequestAttachments from '../../../queries/useRequestAttachments';
import { getBlobUrl } from '../../../helpers/getBlobUrl';
import getRequestAttachment from '../../../requests/getRequestAttachment';
import addRequestAttachment from '../../../requests/addRequestAttachment';
import deleteRequestAttachment from '../../../requests/deleteRequestAttachment';
import CardAttachments from '../../CardAttachments/CardAttachments';
import { queryKeys } from '../../../queries/queryKeys';
import styles from './RequestAttachmentsCard.module.scss';

const pageSize = 4;

const RequestAttachmentsCard = ({
  request = {},
  className,
  cardStyle,
  canChange = true,
}) => {
  const queryClient = useQueryClient();

  const { data: attachments, isFetching: isAttachmentsFetching } =
    useRequestAttachments(request.id);

  const mutationOptions = {
    onSuccess: () =>
      queryClient.invalidateQueries(queryKeys.requestAttachments(request.id)),
  };

  const addAttachmentMutation = useMutation(
    ({ requestId, file }) => addRequestAttachment(requestId, file),
    mutationOptions
  );

  const deleteAttachmentMutation = useMutation(
    ({ requestId, attachId }) => deleteRequestAttachment(requestId, attachId),
    mutationOptions
  );

  const handleAddAttachment = ({ file }) => {
    addAttachmentMutation.mutate({ requestId: request.id, file });
  };

  const handleDeleteAttachment = (attachment) => {
    deleteAttachmentMutation.mutate({
      requestId: request.id,
      attachId: attachment.id,
    });
  };

  const handleBeforeUpload = (file) => {
    if (file.size > maxFileSize) {
      message.error('Файл должен весить не больше 15 мб');
      return false;
    }

    return true;
  };

  const getAttachmentUrl = async (data) => {
    const fileName = typeof data === 'object' ? data.fileName : data;

    const fileExtension = fileName.split('.')[1];

    const attachment = await getRequestAttachment(request.id, fileName);

    const url = getBlobUrl(attachment, fileExtension);

    return url;
  };

  const uploadButtonProps = {
    multiple: true,
    showUploadList: false,
    disabled: addAttachmentMutation.isLoading,
    customRequest: handleAddAttachment,
    beforeUpload: handleBeforeUpload,
  };

  return (
    <CardAttachments
      paginationClassName={styles.pagination}
      title="Вложения"
      pageSize={pageSize}
      uploadButtonProps={uploadButtonProps}
      cardStyle={cardStyle}
      rootClassName={className}
      attachments={attachments}
      getAttachmentUrl={getAttachmentUrl}
      onDeleteAttachment={canChange ? handleDeleteAttachment : undefined}
      showMetaData={false}
      loading={isAttachmentsFetching}
      showUpload={canChange}
    />
  );
};

export default RequestAttachmentsCard;
